import {Timezone, TimezoneOffset} from '@gl/lit/types/timezone.js';

export const TIMEZONES = Intl.supportedValuesOf('timeZone');

export const NO_REGION_TIMEZONES_MAP = new Map<Timezone['name'], Timezone>();
export const TIMEZONES_MAP = new Map<Timezone['name'], Timezone>();
export const REGIONS_SET = new Set<string>();

for (const tz of TIMEZONES) {
  const offset = Intl.DateTimeFormat([], {
    timeZone: tz,
    timeZoneName: 'longOffset',
  })
    .formatToParts()
    .find(part => part.type === 'timeZoneName');

  const timezone = new Timezone(tz, offset!.value);
  const [region, ...nameParts] = tz.split('/');
  const name = nameParts.join('/');

  TIMEZONES_MAP.set(timezone.name, timezone);
  NO_REGION_TIMEZONES_MAP.set(name, timezone);

  region && REGIONS_SET.add(region);
}

export const REGIONS = Array.from(REGIONS_SET).sort();

export const getBrowserTimezoneOffset = (): string => {
  const date = new Date();
  const offset = date
    .toString()
    .split(' ')
    .filter(str => str.startsWith('GMT'))
    .map(value => TimezoneOffset.normalizeOffset(value))
    .at(0);
  return offset ?? 'GMT';
};

export const getBrowserTimezone = (): Timezone => {
  const name = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezone = getTimezone(name);
  return new Timezone(name, timezone?.offset ?? getBrowserTimezoneOffset());
};

export const getTimezone = (name: string, offset?: string): Timezone | null => {
  if (!name) return null;
  let timezone = TIMEZONES_MAP.get(name);
  if (timezone) return new Timezone(name, timezone.offset);
  timezone = NO_REGION_TIMEZONES_MAP.get(name);
  if (timezone) return new Timezone(name, timezone.offset);
  return offset ? new Timezone(name, offset) : null;
};

export function isKnownTimezone(name: string): boolean {
  return TIMEZONES_MAP.has(name);
}

export function getRegionFromTimezone(timezone: Timezone): string {
  const [region] = timezone.name.split('/');
  return region;
}
